module.exports = __webpack_public_path__ + "7d088296/img/rename-icon.de4e673d.svg";